import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PROMO_BANNER_200_CLASSES_I18N_NAMESPACE =
  '@mc/promos/experiments/pen-7565_v1_promo_banner_200_classes'

export const i18nInstance = registerI18nResources({
  namespace: PROMO_BANNER_200_CLASSES_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
